import * as React from 'react';
import { connect } from 'react-redux';

import DropdownItem from './DropdownItem';
import RateInfo from '../Modal/RateInfo';

import { onPlageSearch } from '../../../actions';
import { getConfig } from '../../Utils';
import { IHandlers } from '../../../services/ApiClient';
import axios from 'axios';

interface Props {
  settings?: any;
  onDocument: (properties: {
    comment?: boolean;
    personal?: boolean;
    title?: string;
    sendType?: string;
  }) => void;
  onApplicationPdfDownload: (onSuccess: () => void) => void;
  onRevoke: (comment?: boolean, personal?: boolean, title?: string) => void;
  formType?: string;
  processId?: string | number;
  onPlageSearch?: any;
  isEnglishVersionAvailable?: boolean;
}

interface State {
  expanded: boolean;
  rateQualityModalActive: boolean;
  votingResultsModalActive: boolean;
}

class DropdownButton extends React.Component<Props, State> {
  private root: any = null;

  state = {
    expanded: false,
    rateQualityModalActive: false,
    votingResultsModalActive: false,
  };

  componentWillMount() {
    this.setState({
      expanded: false,
      rateQualityModalActive: false,
      votingResultsModalActive: false,
    });
  }

  componentDidUpdate(
    prevProps: Readonly<any>,
    prevState: Readonly<any>,
    prevContext: any,
  ) {
    if (prevState.expanded !== this.state.expanded) {
      document.body.addEventListener('click', this.forClickEventListener);
    }
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', this.forClickEventListener);
  }

  handlerClick = () => {
    this.setState(({ expanded }) => ({ expanded: !expanded }));
  };

  handlerRateQuality = () => {
    this.setState(({ rateQualityModalActive }) => ({
      rateQualityModalActive: !rateQualityModalActive,
    }));
  };

  handlerVotingPopup = () => {
    this.setState(({ votingResultsModalActive }) => ({
      votingResultsModalActive: !votingResultsModalActive,
    }));
  };

  forClickEventListener = item => {
    if (!this.root.contains(item.target)) {
      if (this.state.expanded) {
        this.handlerClick();
      }
    }
  };

  handlerOnRevoke = () => {
    this.props.onRevoke();
  };

  onSendDocument = (type?: 'status' | 'expertise') => () => {
    if (type) {
      this.props.onDocument({ sendType: type });
    } else {
      this.props.onDocument({});
    }
  };

  renderApplicationLink(lang: 'ru' | 'eng') {
    const linkText =
      lang === 'ru' ? 'Просмотр заявки (RU)' : 'Просмотр заявки (EN)';

    const linkHref = `${getConfig().apiUrl}/item/${this.props.formType}/${
      this.props.processId
    }/pdf/${lang}`;

    const downloadFile = () => {
      // TODO: инкапсулировать логику загрузки файла, не вызывать напрямую здесь
      axios({
        url: linkHref,
        method: 'GET',
        responseType: 'blob',
      })
        .then(response => {
          const href = window.URL.createObjectURL(response.data);

          const anchorElement = document.createElement('a');

          anchorElement.href = href;
          anchorElement.download = `${lang}.pdf`;

          document.body.appendChild(anchorElement);
          anchorElement.click();

          document.body.removeChild(anchorElement);
          window.URL.revokeObjectURL(href);
        })
        .catch(error => {
          console.log('error: ', error);
        });
    };

    const handleLinkClick = () => {
      this.props.onApplicationPdfDownload(downloadFile);
    };

    return (
      <DropdownItem href={linkHref} isDownload={true} onClick={handleLinkClick}>
        {linkText}
      </DropdownItem>
    );
  }

  render() {
    return (
      <>
        <div
          ref={input => {
            this.root = input;
          }}
          className="btn-group dropup"
        >
          <button
            className="btn btn-success btn-sm pull-right dropdown-toggle"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            onClick={this.handlerClick}
          >
            Действия
            <span className="caret" />
          </button>

          <ul
            className="dropdown-menu dropdown-menu-right"
            style={{
              display: this.state.expanded ? 'block' : 'none',
              marginRight: 20,
            }}
            onClick={this.handlerClick}
          >
            <DropdownItem onClick={this.onSendDocument()}>
              Отправить
            </DropdownItem>

            {this.renderApplicationLink(
              this.props.isEnglishVersionAvailable ? 'eng' : 'ru',
            )}
            {/*<DropdownItem onClick={this.handlerRateQuality}>Оценить оригинальность заявки</DropdownItem>*/}
            {/* <DropdownItem onClick={this.handlerOnRevoke}>Отозвать заявку</DropdownItem> */}
            {/*<DropdownItem onClick={this.onSendDocument('expertise')}>*/}
            {/*    Отправить на предварительную экспертизу*/}
            {/*</DropdownItem>*/}
            {/*<DropdownItem onClick={this.onSendDocument('status')}>*/}
            {/*    Отправить на статус участника*/}
            {/*</DropdownItem>*/}
            {/*<DropdownItem onClick={this.handlerVotingPopup}>*/}
            {/*    Посмотреть результаты голосования*/}
            {/*</DropdownItem>*/}
          </ul>

          <RateInfo
            onHide={this.handlerRateQuality}
            show={this.state.rateQualityModalActive}
            onPlageSearch={this.props.onPlageSearch}
          />
        </div>
      </>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  onPlageSearch: (handlers: IHandlers) => {
    dispatch(onPlageSearch(handlers));
  },
});

const mapStateToProps = state => {};

export default connect(mapStateToProps, mapDispatchToProps)(DropdownButton);
